import BaseService from "../BaseService";

class NotificationService extends BaseService {
  list = async (payload = {}) => {
    return await this._api.post("/notification/list", payload);
  };

  read = async ({ id }) => {
    return await this._api.post("/notification/read", { id });
  };

  readAll = async () => {
    return await this._api.post("/notification/readall", {});
  };

  countUnread = async () => {
    return await this._api.post("/notification/countunread", {});
  };

  listRules = async () => {
    return await this._api.post("/notification/rule/list", {});
  };

  saveRule = async (payload) => {
    return await this._api.post("/notification/rule/save", payload);
  };
}

export default NotificationService;
